export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-07.3a27e89f.png";